export const getTaxes = async(
    destination_address: AddressFields | null,
    product_quantities: TaxPreviewProductQuantity[],
    coupons?: string[],
) => {
    const response = await fetch('/wp-json/wr-api/products/tax/preview', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
        body: JSON.stringify({
            coupons,
            destination_address,
            product_quantities,
        }),
    })

    if (response.status !== 200) {
        return
    }
    const tax = await response.json()
    return tax
}